// 日记分享单个事件
import React, { useEffect, useState } from 'react';
import { useRouteMatch, useHistory, useLocation, useParams } from "react-router-dom";
import { Modal, Toast } from 'antd-mobile';
import classnames from 'classnames';
import '../css/Download.scss';
import NoteShareService from '../services/NoteShare';
import { getWeek, getParameter } from '../utils/func';
import moment from 'moment';

const Download = ({ props }) => {
    console.log(props);
    const match = useRouteMatch();
    const location = useLocation();
    const history = useHistory();
    const params = useParams();
    console.log(match, location, history, params);
    useEffect(() => {
        document.title = "下载日刻APP"
        const uuid = getParameter("uuid", location.search);
        if (browser.versions.ios && !browser.versions.weixin) {
            window.location.href = "https://itunes.apple.com/cn/app/id1551902709";
        }
        if (browser.versions.android && !browser.versions.weixin) {
            window.location.href = "noteapp://note.app/open?uuid=" + uuid;
            window.setTimeout(function () {
                window.location.href = "http://download.kairusi.com/1TodoS/1TodoS.apk";//没有本地APP的，就打开输入的网址。    去下载APP的网址
                //微信不让打开外部APP，必须跳到类如应用宝（QQ所属产品）的市场，应用宝会判断本机有没这个APP，有就可以直接打开。
            }, 2000);
        }
    }, []);
    const browser = {
        versions: function () {
            var u = navigator.userAgent, app = navigator.appVersion;
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                souyue: u.indexOf('souyue') > -1,
                superapp: u.indexOf('superapp') > -1,
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == " qq", //是否QQ
                Safari: u.indexOf('Safari') > -1
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    const iosWx = () => {
        window.location.href = "https://itunes.apple.com/cn/app/id1551902709";
    };
    const iosApp = () => {
        window.location.href = "https://itunes.apple.com/cn/app/id1551902709";
    };
    const andriodBrowser = () => {
        window.location.href = "http://download.kairusi.com/1TodoS/1TodoS.apk";
    };
    const andriodWx = () => {
        window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist";
    };
    return <div className="note-download">
        {
            browser.versions.android && browser.versions.weixin
            && <div className="andriod-wx">
                <div className="andriod-wx-top">
                    <div className="andriod-wx-des">若已安装日刻APP</div>
                    <div className="andriod-wx-text">1.点击右上角</div>
                    <div className="andriod-wx-text andriod-wx-text2">2.选择在 <span className="andriod-wx-browser">浏览器</span> 中打开</div>
                    <img src={require("../image/note-mobile.png")} alt="" className="andriod-wx-mobile" />
                    <img src={require("../image/note-andriod-jiantou.png")} alt="" className="andriod-jiantou" />
                </div>
                <div className="download-button" onClick={andriodWx}>下载体验</div>
            </div>
        }
        {
            browser.versions.android && !browser.versions.weixin
            && <div className="note-all-download">
                <div className="note-all-download-top">
                    <img alt="" src={require("../image/download-logo.png")} className="download-logo" />
                    <div className="andriod-wx-des">日刻</div>
                    <div className="andriod-wx-text note-download-text">随时随地，记录美好</div>
                </div>
                <div className="download-button" onClick={andriodBrowser}>下载体验</div>
            </div>
        }
        {
            browser.versions.ios && browser.versions.weixin
            && <div className="note-all-download">
                <div className="note-all-download-top">
                    <img alt="" src={require("../image/download-logo.png")} className="download-logo" />
                    <div className="andriod-wx-des">日刻</div>
                    <div className="andriod-wx-text note-download-text">随时随地，记录美好</div>
                </div>
                <div className="download-button" onClick={iosWx}>下载体验</div>
            </div>
        }
        {
            browser.versions.ios && !browser.versions.weixin
            && <div className="note-all-download">
                <div className="note-all-download-top">
                    <img alt="" src={require("../image/download-logo.png")} className="download-logo" />
                    <div className="andriod-wx-des">日刻</div>
                    <div className="andriod-wx-text note-download-text">随时随地，记录美好</div>
                </div>
                <div className="download-button" onClick={iosApp}>下载体验</div>
            </div>
        }
    </div>
};

export default Download;